import { useTranslate } from '@tolgee/react';
import React from 'react';
import { useDispatch } from 'react-redux';
import MoreInfoIcon from '../../../generic/UIComponents/moreInfoIcon';
import {APPROVAL_STEP_RULE_ANY_TEXT, approvalStepRuleOptions} from '../constants';
import { STEP_1 } from '../../../../redux/slices/LomavisPostApproval/constants';
import {buildApprovalStepRuleLabel} from "../../utils";

const WhoHasToApprove = ({ ruleOption, handleClick }) => {
  const { t } = useTranslate();
  return (
    <div className="rounded p-3 d-flex justify-content-between align-items-center">
      <div className="d-flex align-items-center gap-2 w-100">
        <span className="fw-bold">
          {t('lomavisPostApproval.approvalMessageCard.whoHasToApprove')}
        </span>
          <span className={"mx-2"}>
              <MoreInfoIcon text={t('lomavisCreator.tooltip.whoHasToApprove')} />
          </span>

      </div>

      <div className="dropdown">
        <button
          className="btn btn-secondary btn-sm dropdown-toggle"
          type="button"
          id="approvalDropdown"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
            {t(buildApprovalStepRuleLabel(ruleOption))}
        </button>
        <ul
          className="dropdown-menu dropdown-menu-end"
          aria-labelledby="approvalDropdown"
        >
          {approvalStepRuleOptions.map(({ value, label }) => (
            <li key={value}>
              <button
                className="dropdown-item"
                onClick={() => handleClick(value)}
              >
                {t(buildApprovalStepRuleLabel(label))}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default WhoHasToApprove;
